import { useConfig } from 'shared/config/ConfigContext';
import type { CurrencyData } from '@/interfaces';

interface CurrencyListProps {
    data: Pick<CurrencyData, 'data'>;
    date: string;
}

const displayCurrencies = ['EUR', 'USD', 'GBP', 'DKK', 'SEK', 'THB', 'TRY', 'AUD', 'CAD', 'HKD', 'SGD', 'JPY', 'RUB', 'PLN', 'CHF'];

export const CurrencyList = ({ data, date }: CurrencyListProps) => {
    const { basePath } = useConfig();
    const renderCurrency = (currency, idx) =>
        data[currency] ? (
            <tr className={idx + 1 !== displayCurrencies.length ? 'border-b' : null} key={`list${currency}`}>
                <td className="p-8">
                    <img
                        src={`${basePath}/icons/${currency.toLowerCase()}.svg`}
                        alt={currency}
                        width={24}
                        height={18}
                        className="inline align-text-top border"
                    />
                    <span className="ml-16">{currency}</span>
                </td>
                <td className="p-8 s-text-subtle">
                    {data[currency].unit} {data[currency].name}
                </td>
                <td className="p-8 s-text-subtle hidden sm:block">=</td>
                <td className="p-8 text-right">
                    {`${(Math.round(data[currency].rate * 100) / 100).toString().replace('.', ',')} `}
                    <span className="text-12 s-text-subtle hidden sm:inline">NOK</span>
                </td>
            </tr>
        ) : null;

    return (
        <table className="w-full">
            <thead>
                <tr className="border-b">
                    <th className="p-8 text-left text-22" colSpan={4}>
                        Valutakurser
                        <span className="pt-4 float-right text-16 font-normal s-text-subtle">{date}</span>
                    </th>
                </tr>
            </thead>
            <tbody>{displayCurrencies.map(renderCurrency)}</tbody>
        </table>
    );
};
